import React from 'react'

function Goldengate() {
    return (
<div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Oracle Golden Gate 11G </h1>
          </div>
          <div className="imgSection">
            <img src={require("../../../images/courses/Oracle-golden-gate-pic.jpg")} alt="" />
          </div>
          <div className="heading">
            <h1>Oracle Golden Gate 11G</h1>
            <p>
            The objective of this training is to explain the fundamental concepts of Oracle GoldenGate used for data replication and integration. At the end of this training, the participants are expected to have beginner level knowledge and should be able to start working on live projects. Focus Training services, Pune is the only center who train Professionals at Professional level In this technology.
            </p>

            <h3>Course Description –</h3>

            <h4>Introduction to Oracle Golden Gate</h4>
            <ul>
              <li>Oracle Golden Gate Replication Solutions for Live Reporting, Real Time Data Warehousing, Live Standby Database, and High Availability.</li>
              <li>
                An Overview of: components, internet platform, apps server and
                developer suite
              </li>
              <li>
              Supported databases and platforms
              </li>
              <li>Advantages of Oracle Golden Gate</li>
            </ul>
            {/*  */}
            <h4>
            Installing Oracle Golden Gate
            </h4>
            <ul>
                <li>Downloading the software from Oracle website.</li>
                <li>Installing Oracle Golden Gate</li>
                <li>Explaining Subdirectories</li>
                <li>Preparing Oracle 11g database for data replication</li>
            </ul>

            {/*  */}

            <h4>
            Oracle Golden Gate Technology and Architecture
            </h4>
            <ul>
                <li>Understanding Golden Gate Components: Processes and Files</li>
                <li>Process Data Flow</li>
                <li>GoldenGate Architecture</li>
                <li>Design Considerations</li>
            </ul>
            {/*  */}
            <h4>
            Configuring & Preparing the Environment
            </h4>
            <ul>
                <li>Configuring the Manager process</li>
                <li>Describing the Manager Parameters</li>
                <li>Starting the Manager process</li>
                <li>Configuring GLOBALS file</li>
            </ul>

            {/*  */}
            <h4>
            Data Definitions File
            </h4>
            <ul>
                <li>Overview of Data Definitions File</li>
                <li>When to use Data Definitions Files</li>
                <li>Types of Data Definitions File</li>
                <li>Configuring Data Definitions File</li>
            </ul>
            {/*  */}
            <h4>
            Configuring Change Capture Delivery – With and Without Data Pump
            </h4>
            <ul>
                <li>Preparing a source database for transaction capture</li>
                <li>Describing the high-level configuration steps</li>
                <li>Explaining change capture and delivery with a data pump</li>
                <li>Explaining change capture and delivery without a data pump</li>
                <li>Explaining Oracle Golden Gate Checkpoints</li>
                <li> Describing the Extract process </li>
                <li> Configuring and starting an Extract process </li>
                <li> Adding local and remote trails </li>
                <li> Configuring and starting a data pump </li>
                <li> Explaining the Replicate process </li>
                <li> Configuring a Replicate process </li>
                <li> Starting a Replicate process </li>
                <li> Describing GGSCI commands </li>
                <li> Describing Extract trails and files </li>
            </ul>
            {/*  */}
            <h4>
            Configuring Change Capture Delivery – DDL Replication and Initial Data Load
            </h4>
            <ul>
                <li>Overview of DDL synchronization </li>
                <li>Preparing a source database for transaction capture </li>
                <li> Describing the high-level configuration steps</li>
                <li>Configuring Extract and Replicat for DDL replication </li>
                <li>Configuring Initial Data Load using Oracle GoldenGate Extract and Replica </li>
            </ul>

            {/*  */}

            <h4>
            Oracle Golden Gate Commands   
            </h4>
            <ul>
                <li>Running Golden Gate commands from the GGSCI prompt </li>
                <li>Running Golden Gate commands from the obey files </li>
                <li>Running Golden Gate commands from the OS shell </li>
                <li>Identifying the types of GGSCI commands available </li>
            </ul>
            {/*  */}
            <h4>
            Managing Oracle Golden Gate
            </h4>
            <ul>
                <li>Managing trail files </li>
                <li>Automating process startup </li>
                <li>Using reporting and statistics </li>
            </ul>

            {/*  */}

            <h4>
            Where Do We Go From Here
            </h4>
            <ul>
                <li>  Golden gate Director</li>
                <li> Golden Gate Veridata</li>
                <li> Logdump Utility</li>
                <li>ETL using Golden Gate </li>
            </ul>
           
          </div>
        </div>
      </div>
    </div>
    )
}

export default Goldengate
